import { render, staticRenderFns } from "./promotion-audit-item-details.component.vue?vue&type=template&id=6e4939d0"
import script from "./promotion-audit-item-details.component.vue?vue&type=script&lang=ts"
export * from "./promotion-audit-item-details.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports